import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import type { CreativeLibraryTabProps } from "@/types/creative-library";
import { BrandLibraryTab } from "./BrandLibraryTab";
import { CreativeWorkspace } from "./CreativeWorkspace";
import { normalizeCreativeLibraryRoute } from "./creativeBoardWorkspace";

/** The legacy Boards URL opens the same Creatives workspace, without selecting a Board by guesswork. */
export function CreativeLibraryTab({
  view,
  className,
}: CreativeLibraryTabProps) {
  const [params, setParams] = useSearchParams();
  useEffect(() => {
    if (params.get("view") === "boards")
      setParams(normalizeCreativeLibraryRoute, { replace: true });
  }, [params, setParams]);
  return view === "brands" ? (
    <BrandLibraryTab className={className} />
  ) : (
    <CreativeWorkspace className={className} />
  );
}
